export default __webpack_public_path__ + "static/media/05_Learn-a-new-song.bb54fa55.jpg";